import React, { useCallback, useState } from "react";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";
import { Modal } from "react-responsive-modal";
import { kaReducer, Table } from "ka-table";
import { loadData, updateData, updatePagesCount } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import eomAddonsService from "../services/eom-addons-service";
import moment from "moment";

const AddOnsPage = ({ history }) => {
    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const onCloseModal = () => {
        setOpen(false);
    };

    const [fileContent, setFileContent] = useState({});
    const [month, setMonth] = useState();
    const [year, setYear] = useState(moment().format("YYYY"));
    const [selectMonthForUpload, setSelectMonthForUpload] = useState();
    const [selectYearForUpload, setSelectYearForUpload] = useState(moment().format("YYYY"));


    const totalMonthsList = () => {
        const months = [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
        ];
        return months.map((i, index) => (
            <option value={index + 1} key={i}>
                {i}
            </option>
        ));
    };

    const handleUpload = async (event) => {
        try {
            setLoading(true);
            let formDataUrl = new FormData();
            formDataUrl.append("excel", fileContent);
            formDataUrl.append("enctype", "multipart/form-data");
            await eomAddonsService.uploadAddonsDocument(selectYearForUpload, selectMonthForUpload, formDataUrl);
            onCloseModal();
            setFileContent({});
            setSelectYearForUpload(moment().format("YYYY"));
            setSelectMonthForUpload();
            const { hide } = cogoToast.success(
                "Document uploaded successfully.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
        } catch (e) {
            const { hide } = cogoToast.error(
                "Error uploading document. Please try after sometime.",
                {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                }
            );
            setLoading(false);
        }
        finally {
            setLoading(false);
        }
    };

    const PAGE_SIZE = 20;
    const [searchTerm, setSearchTerm] = useState('');
    const tablePropsInit = {
        columns: [
            { key: "fil_id", title: "Fill ID" },
            { key: "rxf_number", title: "Rx Number" },
            { key: "patient_name", title: "Patient Name" },
            { key: "drug_name", title: "Drug Name" },
            { key: "qty", title: "Quantity" },
            { key: "amt_due", title: "Amount Due" },
        ],
        singleAction: loadData(),
        sortingMode: SortingMode.Single,
        rowKeyField: "rxf_number",
        search: ({ searchText, rowData, column }) => {
            if (column.key === "passed") {
                return (
                    (searchText === "false" && !rowData.passed) ||
                    (searchText === "true" && rowData.passed)
                );
            }
        },
        paging: {
            enabled: true,
            pageIndex: 0,
            pageSize: PAGE_SIZE,
            position: PagingPosition.Bottom,
        },
    };
    const [tableProps, changeTableProps] = useState(tablePropsInit);
    const dispatch = async (action) => {
        changeTableProps((prevState) => kaReducer(prevState, action));
        if (action.type === ActionType.LoadData) {
            dispatch(updateData([]));
        }
        if (action.type === ActionType.UpdatePageIndex) {
            changeTableProps((prev) => ({
                ...prev,
                paging: { ...prev.paging, pageIndex: action.pageIndex },
            }));

            getAddonsData(action.pageIndex, searchTerm, month);
        }
    };

    const getAddonsData = async (currentPageNumber, searchText, currentMonth) => {

        if (!currentMonth && !year) {
            const { hide } = cogoToast.error("Please select month and year", {
                hideAfter: 15,
                onClick: () => {
                    hide();
                },
            });

            return;
        }

        try {
            setLoading(true);
            const pageStart = currentPageNumber * PAGE_SIZE + 1;
            const resp = await eomAddonsService.getEOMAddons(
                year, month, pageStart, PAGE_SIZE, searchText
            );

            if (!resp || !resp.items || resp.items.length <= 0) {
                const { hide } = cogoToast.error("No data found for the specified criteria.", {
                    hideAfter: 15,
                    onClick: () => {
                        hide();
                    },
                });
                dispatch(updatePagesCount(0));
                dispatch(updateData([]));
                return;
            }

            resp.items.sort(
                (d1, d2) => new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
            );

            dispatch(updatePagesCount(Math.ceil(resp.count / PAGE_SIZE)));
            dispatch(updateData(resp.items));
        } catch (error) {
            const { hide } = cogoToast.error("Error getting results. Please try after sometime.", {
                hideAfter: 15,
                onClick: () => {
                    hide();
                },
            });
        } finally {
            setLoading(false);
        }
    };

    const debounce = (func, delay) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    };

    const getAddonsDataDebounced = useCallback(
        debounce((value) => getAddonsData(0, value, month), 500),
        [month]
    );

    const handleChange = (event) => {
        const value = event.currentTarget.value;
        setSearchTerm(value);
        getAddonsDataDebounced(value);
    };

    const totalYears = () => {
        const years = [];
        const dateStart = moment().subtract(1, "y");
        const dateEnd = moment().add(1, "y");
        while (dateEnd.diff(dateStart, "years") >= 0) {
            years.push(dateStart.format("YYYY"));
            dateStart.add(1, "year");
        }
        return years.map((i, index) => (
            <option value={i} key={i}>
                {i}
            </option>
        ));
    };

    return (
        <>
            <CipHeader />
            <div
                className={`inline-block customtop absolute z-50 ${loading ? "show" : "hidden"
                    }`}
            >
                <Loader
                    type="Oval"
                    color="#00BFFF"
                    height={50}
                    width={50}
                    timeout={300000} //3 secs
                />
            </div>
            <Modal open={open} onClose={onCloseModal} center>
                <div className=" px-4 pb-4 ">
                    <h3
                        className="text-lg leading-6 text-gray-900 text-labelclr font-semibold py-4 tracking-wider"
                        id="modal-headline"
                    >
                        Upload Document
                    </h3>
                    <div className="flex flex-col gap-4 justify-center w-full mt-4">
                        <select
                            name="list_month"
                            aria-label="Select Month"
                            value={selectMonthForUpload}
                            onChange={(e) => setSelectMonthForUpload(e.target.value)}
                            className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                        >
                            <option value="0">Select Month</option>
                            {totalMonthsList()}
                        </select>
                        <span>
                            <select
                                name="list_year"
                                aria-label="Select Year"
                                defaultValue={moment().format("YYYY")}
                                onChange={(e) => setSelectYearForUpload(e.target.value)}
                                className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-full"
                            >
                                {totalYears()}
                            </select>
                        </span>
                        <input
                            id="upload"
                            name="upload"
                            type="file"
                            onChange={(e) => {
                                setFileContent(e.target.files[0]);
                            }}
                            className="focus:outline-none focus:none h-10 rounded-md pl-3 text-sm font-normal "
                        />
                    </div>
                    <div className="flex justify-center">
                        <button
                            onClick={() => {
                                handleUpload();
                            }}
                            type="button"
                            disabled={
                                Object.getPrototypeOf(fileContent) === Object.prototype || loading
                            }
                            className={
                                Object.getPrototypeOf(fileContent) === Object.prototype || loading
                                    ? "opacity-50 cursor-not-allowed mr-4 rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                                    : "mr-4 rounded font-medium h-10 text-white w-auto px-4 bg-secondary bg-login_btn mb-3 mt-4 focus:outline-none"
                            }
                        >
                            Upload
                        </button>
                        <button
                            onClick={() => setOpen(false)}
                            type="button"
                            className="mr-2 rounded font-medium h-10 text-white w-auto px-6 bg-grey bg-login_btn mb-3 mt-4 focus:outline-none"
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </Modal>
            <div className="bg-white w-5/6 mx-auto mt-6 mb-4 rounded shadow-md">
                <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
                    <div className="w-1/3 text-darkclr font-semibold leading-10 ">
                        <span className="text-xl">Append to EOM Data</span>
                    </div>
                    <div className="w-full sm:w-2/3 text-right">
                        <span className="mr-3">
                            <button
                                type="submit"
                                className="rounded font-medium h-10 text-white bg-login_btn mb-2 py-2 px-7 focus:outline-none text-sm"
                                aria-label="IMPORT"
                                onClick={() => setOpen(true)}
                            >
                                UPLOAD
                            </button>
                        </span>
                        <span className="relative">
                            <input
                                type="search"
                                value={searchTerm}
                                onChange={handleChange}
                                placeholder=" Search"
                                disabled={!month}
                                className="border rounded w-5/12 mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom disabled:cursor-not-allowed disabled:opacity-60"
                            />
                            <img
                                src="/img/search-2.svg"
                                alt=""
                                className="absolute w-4 h-4 mb-2 right-5 top-2 bottom-3"
                            ></img>
                        </span>
                        <span className="mr-3">
                            <Link
                                to="/eomFiles"
                                className=" bg-header_bg rounded mb-2 py-2 px-7 cursor-pointer text-xs font-bold text-white h-10 inline-block shadow-md leading-6"
                            >
                                GO TO EOM FILES
                            </Link>
                        </span>
                    </div>
                </div>

                <div className="p-2 text-xs usersList gridList overflow-x-auto  ">
                    <select
                        name="list_month"
                        aria-label="Select Month"
                        value={month}
                        onChange={(e) => setMonth(e.target.value)}
                        className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/5"
                    >
                        <option value="0">Select Month</option>
                        {totalMonthsList()}
                    </select>
                    <span className="ml-4">
                        <select
                            name="list_year"
                            aria-label="Select Year"
                            defaultValue={moment().format("YYYY")}
                            onChange={(e) => setYear(e.target.value)}
                            className="border focus:outline-none h-10 rounded-md pl-2 text-sm font-normal w-1/5"
                        >
                            {totalYears()}
                        </select>
                    </span>
                    <span className="ml-4">
                        <button
                            disabled={loading}
                            onClick={() => {
                                getAddonsData(0, searchTerm, month);
                            }}
                            className={
                                loading
                                    ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto h-9 px-8 mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                                    : "text-white w-full sm:w-auto h-9 px-6 cursor-pointer mt-2 sm:mt-5 bg-header_bg rounded text-xs font-medium capitalize focus:outline-none"
                            }
                        >
                            SUBMIT
                        </button>
                    </span>
                </div>
                <div className="p-2 text-xs usersList gridList overflow-x-auto">
                    <Table
                        {...tableProps}
                        dispatch={dispatch}
                    />
                </div>
            </div>
        </>
    );
};

export default withRouter(
    connect(
        () => ({}),
        (dispatch) => {
            return bindActionCreators({}, dispatch);
        }
    )(AddOnsPage)
);
